module.exports = __webpack_public_path__ + "static/img/new_ui_logo.e9b25f10.png";